<template>
<div id="teeth-container" :style="styles.container">
  <div :style="styles.row">
    <div :style="[isActiveTeeth(teethLayout.teethTopJaw.value) ? styles.activeTeethBox : styles.teethBox]" @click.capture="clickTeeth(teethLayout.teethTopJaw.value)">{{ teethLayout.teethTopJaw.label }}</div>
  </div>
  <div :style="styles.row">
    <div id="teeth-top-left-section" :style="styles.topLeft">
        <div v-for="(data, rowIndex) in teethLayout.teethLayoutTopLeft" :key="rowIndex" :style="styles.topLeftRow">
          <div v-for="(col, colIndex) in data" :key="colIndex">
            <div :style="[isActiveTeeth(col.value) ? styles.activeTeethBox : styles.teethBox]" @click.capture="clickTeeth(col.value)">{{ col.label }}</div>
          </div>
        </div>
    </div>
    <div id="teeth-top-right-section" :style="styles.topRight">
        <div v-for="(data, rowIndex) in teethLayout.teethLayoutTopRight" :key="rowIndex" :style="styles.topRightRow">
          <div v-for="(col, colIndex) in data" :key="colIndex">
            <div :style="[isActiveTeeth(col.value) ? styles.activeTeethBox : styles.teethBox]" @click.capture="clickTeeth(col.value)">{{ col.label }}</div>
          </div>
        </div>
    </div>
  </div>
  <div :style="[isActiveTeeth(teethLayout.teethAll.value) ? styles.activeAllTeethBox : styles.allTeethBox]" @click.capture="clickTeeth(teethLayout.teethAll.value)">{{ teethLayout.teethAll.label }}</div>
  <div :style="styles.row">
    <div id="teeth-bottom-left-section" :style="styles.bottomLeft">
        <div v-for="(data, rowIndex) in teethLayout.teethLayoutBottomLeft" :key="rowIndex" :style="styles.bottomLeftRow">
          <div v-for="(col, colIndex) in data" :key="colIndex">
            <div :style="[isActiveTeeth(col.value) ? styles.activeTeethBox : styles.teethBox]" @click.capture="clickTeeth(col.value)">{{ col.label }}</div>
          </div>
        </div>
    </div>
    <div id="teeth-bottom-right-section" :style="styles.bottomRight">
        <div v-for="(data, rowIndex) in teethLayout.teethLayoutBottomRight" :key="rowIndex" :style="styles.bottomRightRow">
          <div v-for="(col, colIndex) in data" :key="colIndex">
            <div :style="[isActiveTeeth(col.value) ? styles.activeTeethBox : styles.teethBox]" @click.capture="clickTeeth(col.value)">{{ col.label }}</div>
          </div>
        </div>
    </div>
  </div>
  <div :style="styles.row">
    <div :style="[isActiveTeeth(teethLayout.teethBottomJaw.value) ? styles.activeTeethBox : styles.teethBox]" @click.capture="clickTeeth(teethLayout.teethBottomJaw.value)">{{ teethLayout.teethBottomJaw.label }}</div>
  </div>
</div>
</template>

<script>
export default {
  props: ['activeTeeths'],
  data() {
    return {
      teethConfig: [],
      styles: {
        container: {
          display: 'flex',
          position: 'relative',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          padding: '20px',
        },
        row: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
        },
        topLeft: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '50%',
          borderRightWidth: '1px',
          borderRightStyle: 'solid',
          borderRightColor: 'black',
          borderBottomWidth: '1px',
          borderBottomStyle: 'solid',
          borderBottomColor: 'black',
        },
        topLeftRow: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          alignItems: 'center',
          width: '100%',
        },
        topRight: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '50%',
          borderLeftWidth: '1px',
          borderLeftStyle: 'solid',
          borderLeftColor: 'black',
          borderBottomWidth: '1px',
          borderBottomStyle: 'solid',
          borderBottomColor: 'black',
        },
        topRightRow: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          width: '100%',
        },
        bottomLeft: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '50%',
          borderRightWidth: '1px',
          borderRightStyle: 'solid',
          borderRightColor: 'black',
          borderTopWidth: '1px',
          borderTopStyle: 'solid',
          borderTopColor: 'black',
        },
        bottomLeftRow: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          alignItems: 'center',
          width: '100%',
        },
        bottomRight: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '50%',
          borderLeftWidth: '1px',
          borderLeftStyle: 'solid',
          borderLeftColor: 'black',
          borderTopWidth: '1px',
          borderTopStyle: 'solid',
          borderTopColor: 'black',
        },
        bottomRightRow: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          width: '100%',
        },
        teethBox: {
          padding: '20px',
          margin: '10px',
          borderRadius: '2px',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: '#CACCCF',
          boxShadow: `0 3px 10px rgba(0,0,0,.1), 0 3.5px 5px rgba(204,150,44,.1)`,
          cursor: 'pointer',
        },
        allTeethBox: {
          position: 'absolute',
          left: '50%',
          zIndex: '100px',
          backgroundColor: 'white',
          padding: '10px',
          width: '50px',
          marginLeft: '-25px',
          borderRadius: '2px',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: '#CACCCF',
          boxShadow: `0 3px 10px rgba(0,0,0,.1), 0 3.5px 5px rgba(204,150,44,.1)`,
          cursor: 'pointer',
          textAlign: 'center',
        },
        activeTeethBox: {
          backgroundColor: 'green',
          color: 'white',
          padding: '20px',
          margin: '10px',
          borderRadius: '2px',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: '#CACCCF',
          boxShadow: `0 3px 10px rgba(0,0,0,.1), 0 3.5px 5px rgba(204,150,44,.1)`,
        },
        activeAllTeethBox: {
          backgroundColor: 'green',
          color: 'white',
          position: 'absolute',
          left: '50%',
          zIndex: '100px',
          padding: '10px',
          width: '50px',
          marginLeft: '-25px',
          borderRadius: '2px',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: '#CACCCF',
          textAlign: 'center',
          boxShadow: `0 3px 10px rgba(0,0,0,.1), 0 3.5px 5px rgba(204,150,44,.1)`,
        },
      },
      teethLayout: {
        teethAll: {
          label: 'All',
          value: 'All',
        },
        teethTopJaw: {
          label: 'RA',
          value: 'RA'
        },
        teethBottomJaw: {
          label: 'RB',
          value: 'RB'
        },
        teethLayoutTopLeft: [
          [
            {
              label: '8',
              value: '18'
            },
            {
              label: '7',
              value: '17'
            },
            {
              label: '6',
              value: '16'
            },
            {
              label: '5',
              value: '15'
            },
            {
              label: '4',
              value: '14'
            },
            {
              label: '3',
              value: '13'
            },
            {
              label: '2',
              value: '12'
            },
            {
              label: '1',
              value: '11'
            }
          ],
          [
            {
              label: 'V',
              value: '55'
            },
            {
              label: 'IV',
              value: '54'
            },
            {
              label: 'III',
              value: '53'
            },
            {
              label: 'II',
              value: '52'
            },
            {
              label: 'I',
              value: '51'
            }
          ],
        ],
        teethLayoutTopRight: [
          [
            {
              label: '1',
              value: '21'
            },
            {
              label: '2',
              value: '22'
            },
            {
              label: '3',
              value: '23'
            },
            {
              label: '4',
              value: '24'
            },
            {
              label: '5',
              value: '25'
            },
            {
              label: '6',
              value: '26'
            },
            {
              label: '7',
              value: '27'
            },
            {
              label: '8',
              value: '28'
            }
          ],
          [
            {
              label: 'I',
              value: '61'
            },
            {
              label: 'II',
              value: '62'
            },
            {
              label: 'III',
              value: '63'
            },
            {
              label: 'IV',
              value: '64'
            },
            {
              label: 'V',
              value: '65'
            }
          ],
        ],
        teethLayoutBottomLeft: [
          [
            {
              label: 'V',
              value: '85'
            },
            {
              label: 'IV',
              value: '84'
            },
            {
              label: 'III',
              value: '83'
            },
            {
              label: 'II',
              value: '82'
            },
            {
              label: 'I',
              value: '81'
            }
          ],
          [
            {
              label: '8',
              value: '48'
            },
            {
              label: '7',
              value: '47'
            },
            {
              label: '6',
              value: '46'
            },
            {
              label: '5',
              value: '45'
            },
            {
              label: '4',
              value: '44'
            },
            {
              label: '3',
              value: '43'
            },
            {
              label: '2',
              value: '42'
            },
            {
              label: '1',
              value: '41'
            }
          ],
        ],
        teethLayoutBottomRight: [
          [
            {
              label: 'I',
              value: '71'
            },
            {
              label: 'II',
              value: '72'
            },
            {
              label: 'III',
              value: '73'
            },
            {
              label: 'IV',
              value: '74'
            },
            {
              label: 'V',
              value: '75'
            }
          ],
          [
            {
              label: '1',
              value: '31'
            },
            {
              label: '2',
              value: '32'
            },
            {
              label: '3',
              value: '33'
            },
            {
              label: '4',
              value: '34'
            },
            {
              label: '5',
              value: '35'
            },
            {
              label: '6',
              value: '36'
            },
            {
              label: '7',
              value: '37'
            },
            {
              label: '8',
              value: '38'
            }
          ],
        ],
      },
    }
  },
  methods: {
    isActiveTeeth(value) {
      return this.activeTeeths.findIndex(at => at === value) > -1;
    },
    clickTeeth(value) {
      this.$emit('teethClicked', value)
    }
  }
}
</script>